import React from 'react';
import { CopyLinkInput } from '@components/common/CopyLinkInput';
import { ButtonClean, Colors, List, Pagination, Skeleton, Subsection, Table, Tooltip, useMediaQueryContext, } from '@fourthwall/components';
import { QuestionMarkIcon } from '@fourthwall/icons';
import { getAffiliateDescription } from '../../../../modules/Recommendations/modules/ReferralRecommendation/utils/getAffiliateDescription';
import BlogThumbnail from './assets/blog-thumbnail.webp';
import { BlogLink } from './components/BlogLink/BlogLink';
import { ReferralListItem } from './components/RefferalsListItem/ReferralsListItem';
export const ReferralsView = ({ referrals, shortLink, page, total, limit, totalPages, setPage, title, description, }) => {
    const { tablet } = useMediaQueryContext();
    const headers = [
        {
            label: 'Site',
            id: 'shopName',
            minWidth: 400,
            render: (row) => {
                const { name, description } = getAffiliateDescription(row.affiliateTypeId);
                return (React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2px',
                        color: row.isExpired ? Colors.GS600 : Colors.GS1000,
                    } },
                    React.createElement(ButtonClean, { label: row.shopName, href: `${row.shopDomain}`, target: "_blank" }),
                    React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '6px', color: Colors.GS600 } },
                        name,
                        React.createElement(Tooltip, { reference: React.createElement(QuestionMarkIcon, null) }, description))));
            },
        },
        {
            label: 'Started',
            id: 'fromTime',
            render: (row) => (React.createElement("div", { style: { color: row.isExpired ? Colors.GS600 : Colors.GS1000 } }, row.fromTime.toLocaleDateString())),
        },
        {
            label: 'Ends',
            id: 'toTime',
            render: (row) => (React.createElement("div", { style: { color: row.isExpired ? Colors.GS600 : Colors.GS1000 } }, row.toTime.toLocaleDateString())),
        },
    ];
    const data = referrals.map((referral) => ({
        ...referral,
        isExpired: new Date(referral.toTime) < new Date(),
        fromTime: new Date(referral.fromTime),
        toTime: new Date(referral.toTime),
    }));
    return (React.createElement(React.Fragment, null,
        React.createElement(Subsection, { title: title }, shortLink ? (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '16px' } },
            React.createElement("div", null, description),
            React.createElement(CopyLinkInput, { href: shortLink }),
            React.createElement(BlogLink, { title: "Learn tips & tricks for referrals", description: "A Guide to Fourthwall's Affiliate Programs: How to Qualify and Earn Rewards", href: "https://fourthwall.com/referral-program", thumbnail: BlogThumbnail }))) : (React.createElement(Skeleton, null,
            React.createElement(Skeleton.Shape, { width: 200, height: 48 })))),
        React.createElement(Subsection, { title: "Your referrals", borderless: true },
            React.createElement("div", { style: { marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '12px' } },
                tablet ? (React.createElement(Table, { headers: headers, data: data, emptyMessage: "You don't have any referrals yet.", minWidth: 500 })) : (React.createElement(List, { data: data, renderItem: (item) => React.createElement(ReferralListItem, { item: item }) })),
                totalPages > 1 && (React.createElement(Pagination, { pageCount: totalPages, currentPage: page, total: { count: total, limit }, onChange: setPage }))))));
};
